import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { TemplateElement, FontWeight, FontStyle, TextAlign } from '../../models/receipt-template.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-element-properties',
  templateUrl: './element-properties.component.html',
  styleUrls: ['./element-properties.component.scss'],
})
export class ElementPropertiesComponent implements OnChanges {

  @Input()  element!: TemplateElement;
  @Input()  canvasWith = 210;
  @Input()  canvasHeight = 297;

  @Output() elementChanged = new EventEmitter<TemplateElement>();
  @Output() elementRemoved = new EventEmitter<TemplateElement>();
  @Output() bringForward   = new EventEmitter<TemplateElement>();
  @Output() sendBackward   = new EventEmitter<TemplateElement>();

  // Working copy to avoid mutating input
  public draft!: TemplateElement;

  public fontSizeOptions = [6, 7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48];

  constructor(private translate: TranslateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['element']) {
      this.draft = { ...this.element };
    }
  }

  get typeLabel(): string {
    const keyMap: Record<string, string> = {
      field:   'bikeshop.receipt_template.properties.type_text_field',
      barcode: 'bikeshop.receipt_template.properties.type_barcode',
      qrcode:  'bikeshop.receipt_template.properties.type_qrcode',
      image:   'bikeshop.receipt_template.properties.type_image',
      table:   'bikeshop.receipt_template.properties.type_table',
      divider: 'bikeshop.receipt_template.properties.type_divider',
      header:  'bikeshop.receipt_template.properties.type_header',
      text:    'bikeshop.receipt_template.properties.type_free_text',
    };
    const key = keyMap[this.element.elementType];
    return key ? this.translate.instant(key) : this.element.elementType;
  }

  get showTextOptions(): boolean {
    return ['field', 'header', 'table', 'text'].includes(this.element.elementType);
  }

  get isFreeText(): boolean {
    return this.element.elementType === 'text';
  }

  emit(): void {
    this.elementChanged.emit({ ...this.draft });
  }

  setFontWeight(w: FontWeight): void {
    this.draft.fontWeight = w;
    this.emit();
  }

  setFontStyle(s: FontStyle): void {
    this.draft.fontStyle = s;
    this.emit();
  }

  setTextAlign(a: TextAlign): void {
    this.draft.textAlign = a;
    this.emit();
  }

  clampX(): void {
    this.draft.x = Math.max(0, Math.min(this.draft.x, this.canvasWith - this.draft.width));
    this.emit();
  }

  clampY(): void {
    this.draft.y = Math.max(0, Math.min(this.draft.y, this.canvasHeight - this.draft.height));
    this.emit();
  }

  confirmRemove(): void {
    this.elementRemoved.emit(this.element);
  }
}
